// Google Analytics helper functions
import { sanitizeInput } from './sanitize';

export const pageview = (url: string) => {
  if (typeof window !== 'undefined' && (window as any).gtag) {
    const trackingId = process.env.REACT_APP_GA_TRACKING_ID;
    if (trackingId) {
      (window as any).gtag('config', trackingId, {
        page_path: sanitizeInput(url),
      });
    }
  }
};

export const event = ({ action, category, label, value }: {
  action: string;
  category: string;
  label?: string;
  value?: number;
}) => {
  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('event', sanitizeInput(action), {
      event_category: sanitizeInput(category),
      event_label: label ? sanitizeInput(label) : undefined,
      value: value,
    });
  }
};

// Track button clicks
export const trackButtonClick = (buttonName: string) => {
  event({
    action: 'click',
    category: 'Button',
    label: buttonName,
  });
};

// Track WhatsApp clicks
export const trackWhatsAppClick = (source: string) => {
  event({
    action: 'whatsapp_click',
    category: 'Contact',
    label: source,
  });
};

// Track phone calls
export const trackPhoneCall = (source: string) => {
  event({
    action: 'phone_call',
    category: 'Contact',
    label: source,
  });
};
